import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatTableModule} from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import { HistoryProductComponent } from './history-product.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import {MatInputModule} from '@angular/material/input';

const rutas: Routes = [
      {
        path     : 'history/producto',
        component: HistoryProductComponent,
        canActivate: [AuthGuard]
    }

];

@NgModule({
    imports: [
        RouterModule.forChild(rutas),
        MatIconModule,
        TranslateModule,
        FlexLayoutModule,
        MatTableModule,
        CommonModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatSidenavModule,
        MatDatepickerModule,
        MatFormFieldModule,
        FormsModule,
        MatInputModule
    ],

    declarations: [HistoryProductComponent]
})
export class HistoryProductModule
{
}
